export const customerOrderPackageTypeLabels = {
	PARCEL: "Lava",
	BOX: "Laatikko",
	PACK: "Paketti",
	OTHER: "Tilaelementti",
	OTHER2: "Elementtipaketti",
	OTHER3: "Kalusterunko",
} as const;
